export const GET_BANNERS_LIST = 'GET_BANNERS_LIST'
export const SET_BANNERS_LIST = 'SET_BANNERS_LIST'
export const ADD_NEW_BANNER = 'ADD_NEW_BANNER'
export const DELETE_BANNER = 'DELETE_BANNER'
export const UPLOAD_BANNER = 'UPLOAD_BANNER'